import React, {useEffect, useState} from "react";
import {Loader} from "@googlemaps/js-api-loader";
import findMapsKey from "../../../components/findMapsKey";
import GoogleMapsAPIContextProvider from "./GoogleMapsAPIContextProvider";

const GoogleMapsAPILoader = (props) => {

  const [loading, setLoading] = useState(true);
  const [api, setApi] = useState('');
  const [places, setPlaces] = useState(undefined);


  useEffect(() => {
    if (!api) {
      setApi(findMapsKey());
    }
  }, []);

  useEffect(() => {

    if (api) {
      const loader = new Loader({
        apiKey: api,
        version: 'weekly',
        libraries: ['places']
      });

      loader
        .importLibrary('places')
        .then((library) => {
          setPlaces(library);
          setLoading(false);
        });

    }

  }, [api])

  if (loading) {
    return null;
  }

  return <GoogleMapsAPIContextProvider.Provider value={{
    places: places
  }}>
    <div>
      {props.children}
    </div>
  </GoogleMapsAPIContextProvider.Provider>

}


export default GoogleMapsAPILoader;
